import { takeQuery, createApiHandler } from '../../agent';
import types from './types';

const Version = {
	getVersion: params => {
		const { api, axiosConfig } = params;
		let usedApi;
		if (api){
			usedApi = api;
		} else{
			usedApi = createApiHandler(axiosConfig, null, null)
		}
		return usedApi.get(`/version`);
	}
};

const versionSagas = [takeQuery(types.GET_VERSION, Version.getVersion)];

export default versionSagas;
